var friendInformation =
    [
        {
            "id": 1,
            "name": "Leanne Graham",
            "email": "leanne.g@hildegard.org",
            "annualIncome": 140000,
            "img":"https://i.ibb.co/GCg1NrT/rfrancis.jpg ",
            "city": "Huay",
            "phone": "770-736-8031",
            "website": "www.hildegard.org",
            "job": "Data Architect",
        },

        {
            "id": 2,
            "name": "Mrs. Dennis Schulist",
            "email": "dennis.sc@anastasia.net",
            "annualIncome": 70000,
            "img":"https://i.ibb.co/gSSwQ3V/danni-wright-square.jpg",
            "city": "Wyburgh",
            "phone": "010-692-6593",
            "website": "www.anastasia.net",
            "job": "Chief Marketing Officer",
        },

        {
            "id": 3,
            "name": "Clementinel Bauch",
            "email": "cbauch@ramiro.infot",
            "annualIncome": 60000, 
            "img":"https://i.ibb.co/5MgZD1h/images-1.jpg",
            "city": "McKenziehaven",
            "phone": "463-123-4447",
            "website": "www.ramiro.info",
            "job": "Graphics Designer",
        },
        
        {
            "id": 4,
            "name": "Patricia Lebsack",
            "email": "plebsack@kale.biz",
            "annualIncome": 75000, 
            "img":"https://i.ibb.co/nbT4H5m/images-5.jpg",
            "city": "South Elvis",
            "phone": "493-170-9623",
            "website": "www.kale.biz",
            "job": "Database Engineer",
        },

        {
            "id": 5,
            "name": "Chelsey Dietrich",
            "email": "chelsey.die@demarco.info",
            "img":"https://i.ibb.co/4pC8nTb/images-4.png",
            "annualIncome": 60000, 
            "city": "Roscoeview",
            "phone": "254-954-1289",
            "website": "www.demarco.info",
            "job": "Web Developer",
        },

        {
            "id": 6,
            "name": "Ervin Howell",
            "email": "ervin.howell@ola.org",
            "img":"https://i.ibb.co/k8Ydhz8/images-5.png",
            "annualIncome": 45000, 
            "job": "Technical Specialist",
            "city": "South Christy",
            "phone": "477-935-8478",
            "website": "www.ola.org",
        },

        {
            "id": 7,
            "name": "Kurtis Weissnat",
            "email": "kurtis-weissnat@elvis.io",
            "img":"https://i.ibb.co/fN1bhWL/images-6.png",
            "annualIncome": 85000, 
            "city": "Howemouth",
            "phone": "210-067-6132",
            "website": "www.elvis.io",
            "job": "DevOps Engineer",
        },

        {
            "id": 8,
            "name": "Nicholas Runolfsdottir V",
            "email": "nicholas@jacynthe.com",
            "img":"https://i.ibb.co/2W4cCkG/images-4.jpg",
            "annualIncome": 40000, 
            "city": "Aliyaview",
            "phone": "586.493.6943",
            "website": "www.jacynthe.com",
            "job": "Chief Technology Officer (CTO)",
        },

        {
            "id": 9,
            "name": "Glenna Reichert",
            "email": "clenna.rai@conrad.com",
            "city": "Bartholomebury",
            "phone": "775-976-6794",
            "website": "www.conrad.com",
            "job": "Application Developer",
            "img":"https://i.ibb.co/cgMbbK3/images-2.jpg",
            "annualIncome": 30000, 
        },

        {
            "id": 10,
            "name": "Atakia Nakiso",
            "email": "atk.nakiso@amklose.org",
            "img":"https://i.ibb.co/zN0r8Sp/823377f50eb96b233ce32b0d40863060.jpg",
            "annualIncome": 55000, 
            "job": "Cloud Architect",
            "city": "Lebsackbury",
            "phone": "024-648-3804",
            "website": "www.amklose.org",
        },

        {
            "id": 11,
            "name": "Mentina DuBuque",
            "email": "m.dubuque@rrvdms.net",
            "img":"https://i.ibb.co/47PQNrz/georgia-taylorbrown-GBR.jpg",
            "annualIncome": 65000, 
            "job": "Storage Architect",
            "city": "South Kerolina",
            "phone": "416-648-3804",
            "website": "www.rrvdms.net",
        },

        {
            "id": 12,
            "name": "Albert Domingo",
            "email": "alb.domingo@asdbrose.net",
            "img":"https://i.ibb.co/kHNs3ct/images.jpg",
            "annualIncome": 95000, 
            "job": "Chief Information Officer",
            "city": "Houston",
            "phone": "516-648-3804",
            "website": "www.asdbrose.net",
        },

        {
            "id": 13,
            "name": "Natalon Miru",
            "email": "atk.nakiso@amklose.org",
            "img":"https://i.ibb.co/f4fLJkJ/2397974.png",
            "annualIncome": 85000, 
            "job": "Software Architect",
            "city": "Florida",
            "phone": "124-648-3804",
            "website": "amklose.org",
        },

        {
            "id": 14,
            "name": "Francis Backen Baui",
            "email": "m.dubuque@rrvdms.net",
            "img":"https://i.ibb.co/6gtYKFC/01-shutterstock-476340928-Irina-Bg-1024x683.jpg",
            "annualIncome": 135000, 
            "job": "Data Scientist",
            "city": "Unay",
            "phone": "426-648-3804",
            "website": "www.rrvdms.net",
        },

        {
            "id": 15,
            "name": "Ramond Franchis",
            "email": "alb.domingo@asdbrose.net",
            "img":"https://i.ibb.co/sW75KLP/profile-picture.jpg",
            "annualIncome": 115000, 
            "job": "Chief Information Security Officer",
            "city": "Khaiber",
            "phone": "916-648-3804",
            "website": "www.asdbrose.net",
        }
    ];

export default friendInformation;